import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [team, setTeam] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    try {
      const [c, t, r] = await Promise.all([
        api.get("/content"),
        api.get("/team"),
        api.get("/reviews?status=approved"),
      ]);
      setContent(c.data);
      setTeam(t.data);
      setReviews(r.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  return (
    <ContentContext.Provider value={{ content, team, reviews, loading, refetch: fetchAll }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
